export const MONO = '"Geist Mono", ui-monospace, monospace';

const LAYOUTS = { minimal: "minimal", luxe: "minimal", future: "future", glass: "future", corporate: "corporate", soft: "corporate", creative: "creative", bold: "creative" };
export const layoutOf = (template) => LAYOUTS[template] || "minimal";

export function makeTheme(style) {
  const c = style.colors;
  const r = Number(style.radius) || 0;
  const tpl = layoutOf(style.template);
  const future = tpl === "future";
  const pill = style.button_style === "pill";
  const btnR = pill ? 9999 : r;
  const glass = { background: `${c.surface}B3`, border: `1px solid ${c.border}`, backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)" };
  const primary = { background: c.button, color: c.button_text, border: `1px solid ${c.button}`, borderRadius: btnR, boxShadow: future ? `0 0 40px -10px ${c.accent}99` : "none" };
  const secondary =
    style.button_style === "outline"
      ? { background: "transparent", color: c.title, border: `1px solid ${c.title}33`, borderRadius: btnR }
      : future
        ? { ...glass, color: c.title, borderRadius: btnR }
        : { background: c.surface, color: c.title, border: `1px solid ${c.border}`, borderRadius: btnR };
  const ring = { border: `1px solid ${c.title}22`, borderRadius: 9999, color: c.title };
  const quick = {
    minimal: { ...ring, background: c.surface, border: "none" },
    corporate: { background: c.accent, color: "#fff", borderRadius: 12 },
    creative: { background: c.accent, color: "#fff", borderRadius: 9999 },
    future: { ...glass, color: c.accent, borderRadius: 18, boxShadow: `0 0 24px -10px ${c.accent}` },
  }[tpl] || ring;
  const social = {
    minimal: { ...ring, background: c.surface, border: "none" },
    corporate: { background: c.surface, border: `1px solid ${c.border}`, borderRadius: 10, color: c.title },
    creative: { background: c.surface, border: `1px solid ${c.border}`, borderRadius: 9999, color: c.title },
    future: { ...glass, color: c.title, borderRadius: 14 },
  }[tpl] || ring;
  return {
    tpl,
    c,
    r,
    btnR,
    heading: { fontFamily: `"${style.font_heading}", -apple-system, Georgia, serif`, color: c.title },
    body: { fontFamily: `"${style.font_body}", -apple-system, system-ui, sans-serif`, color: c.text },
    primary,
    secondary,
    quick,
    social,
    chip: { color: c.accent, background: `${c.accent}${future ? "1F" : "14"}`, borderRadius: tpl === "creative" ? 9999 : future ? 10 : 8 },
    boxed: tpl === "corporate" || future,
    surface: future
      ? { ...glass, borderRadius: Math.max(r, 16), boxShadow: "inset 0 1px 0 rgba(255,255,255,0.05)" }
      : {
          background: c.surface,
          border: `1px solid ${c.border}`,
          borderRadius: Math.max(r, tpl === "corporate" ? 12 : r),
          boxShadow: tpl === "corporate" ? "0 10px 30px -18px rgba(15,30,54,0.35)" : "none",
        },
    avatarR: style.avatar_shape === "circle" ? 9999 : style.avatar_shape === "rounded" ? 20 : Math.min(r, 6),
  };
}
